export default __webpack_public_path__ + "static/media/CIA-Alternative-Energy-November2025.ad8b22d8.pdf";